// src/pages/ManagingDirector.js
import React from 'react';
import '../HumanResources.css';

function ManagingDirector() {
  return (
    <div className="hr-page">
      <h1>MANAGING DIRECTOR</h1>

      {/* Overview Section */}
      <h2>Overview</h2>
      <p>
        The Managing Director provides strategic direction and leadership to Nesim. Their responsibilities include:
      </p>
      <ul>
        <li><strong>Strategic Planning &amp; Leadership:</strong> Overseeing the entire organization.</li>
        <li><strong>Operational Oversight:</strong> Monitoring day-to-day operations to ensure efficiency.</li>
        <li><strong>Implementation of Strategic Plans:</strong> Guiding the company towards its goals.</li>
        <li><strong>Senior Management Leadership:</strong> Leading the senior management team with direction and support.</li>
        <li><strong>Financial Monitoring:</strong> Ensuring the company’s financial health.</li>
        <li><strong>Stakeholder Management:</strong> Managing relationships and maintaining positive external connections.</li>
        <li><strong>Decision Making:</strong> Making critical decisions regarding the company’s direction and operations.</li>
        <li><strong>Regulatory Compliance:</strong> Ensuring adherence to regulations and avoiding legal issues.</li>
        <li><strong>Growth Identification:</strong> Identifying opportunities for expansion and driving growth.</li>
        <li><strong>Culture &amp; Engagement:</strong> Fostering a positive company culture and promoting employee engagement.</li>
        <li><strong>Financial &amp; Market Analysis:</strong> Reviewing financial performance and market trends to guide strategic decisions.</li>
        <li><strong>Operational Efficiency:</strong> Overseeing and enhancing operational processes.</li>
        <li><strong>Board Engagement:</strong> Representing the company in board meetings.</li>
      </ul>

      {/* Proposed Job Levels Section */}
      <h2>Proposed Job Levels for the Managing Director Role</h2>
      <p>
        This career progression outlines potential levels for the Managing Director role at Nesim, from overall strategic leadership to expanded responsibilities in deputy and assistant roles.
      </p>

      {/* Level 1 */}
      <div className="subcard">
        <h3>Level 1: Managing Director</h3>
        <ul>
          <li>
            <strong>Focus:</strong> Strategic planning, overall leadership, and overseeing daily operations.
          </li>
          <li>
            <strong>Key Responsibilities:</strong>
            <ul>
              <li>Strategic planning and leadership of all teams and departments.</li>
              <li>Overseeing day-to-day operations.</li>
              <li>Implementing strategic plans across the organization.</li>
              <li>Leading and guiding the senior management team.</li>
              <li>Monitoring financial performance and ensuring fiscal health.</li>
              <li>Managing key stakeholder relationships.</li>
              <li>Making pivotal decisions for the company's direction.</li>
              <li>Ensuring regulatory compliance.</li>
              <li>Identifying and driving growth opportunities.</li>
              <li>Fostering a positive company culture.</li>
              <li>Reviewing financial performance and market trends.</li>
              <li>Developing and implementing strategic plans.</li>
              <li>Overseeing operational efficiency.</li>
              <li>Managing key client and stakeholder relationships.</li>
              <li>Attending board meetings and providing leadership guidance.</li>
              <li>Staying updated on industry developments.</li>
            </ul>
          </li>
        </ul>
      </div>

      {/* Level 2 */}
      <div className="subcard">
        <h3>Level 2: Deputy Managing Director / Chief Operating Officer (COO)</h3>
        <ul>
          <li>
            <strong>Focus:</strong> Supporting the Managing Director in strategy implementation and overseeing operational functions.
          </li>
          <li>
            <strong>Key Responsibilities:</strong>
            <ul>
              <li>Managing day-to-day operations and reporting to the Managing Director.</li>
              <li>Ensuring the efficient implementation of strategic plans.</li>
              <li>Overseeing departmental performance.</li>
              <li>Assisting in financial performance monitoring and identifying efficiency improvements.</li>
              <li>Managing internal stakeholder relationships and facilitating inter-department communication.</li>
              <li>Deputizing for the Managing Director when necessary.</li>
              <li>Leading targeted strategic projects or initiatives.</li>
            </ul>
          </li>
        </ul>
      </div>

      {/* Level 3 */}
      <div className="subcard">
        <h3>Level 3: Assistant Managing Director / General Manager</h3>
        <ul>
          <li>
            <strong>Focus:</strong> Managing a significant division or functional area within the company.
          </li>
          <li>
            <strong>Key Responsibilities:</strong>
            <ul>
              <li>Developing and implementing strategic plans for their specific division.</li>
              <li>Overseeing operational performance and financial results of the division.</li>
              <li>Leading and managing teams within their area of responsibility.</li>
              <li>Building and maintaining relationships with key stakeholders relevant to the division.</li>
              <li>Identifying growth opportunities within their division.</li>
              <li>Ensuring regulatory compliance within their functional area.</li>
              <li>Contributing to overall strategic discussions and decision-making processes.</li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  );
}

export default ManagingDirector;
